<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12" md="12">
        <material-card title="Busque pelo CPF">
          <v-form ref="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="3" sm="6">
                  <custom-input-mask
                    autofocus
                    ref="txtCpf"
                    :rules="requiredRule"
                    label="CPF"
                    :mask="['###.###.###-##']"
                    v-model="cpf"
                  ></custom-input-mask>
                </v-col>
                <v-col class="mt-3" cols="12" md="6" sm="6">
                  <v-btn @click="buscar()" color="success">
                    <v-icon left>mdi-magnify</v-icon>Buscar
                  </v-btn>
                  <v-btn @click="limpar()" class="ml-1" color="primary">
                    <v-icon left>mdi-autorenew</v-icon>Limpar
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" sm="6">
                  <v-text-field disabled label="Nome" v-model="cliente.nome" />
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <v-text-field
                    disabled
                    label="Email"
                    v-model="cliente.email"
                  />
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <custom-input-mask
                    disabled
                    label="Telefone"
                    :mask="['(##)####-####', '(##)#####-####']"
                    v-model="cliente.celular"
                  ></custom-input-mask>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
        <material-card title="Boletos" class="mt-3" v-if="cliente.id">
          <v-form ref="formBoleto">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="6" sm="9">
                  <v-text-field
                    ref="txtLinhaDigitavel"
                    required
                    v-numericOnly
                    @keyup.ctrl.86="ctrlV()"
                    @change="onChangeLinhaDigitavel"
                    maxlength="100"
                    label="Linha Digitável"
                    v-model="linhaDigitavel"
                  />
                </v-col>
                <v-col cols="12" md="3" sm="3">
                  <custom-date-picker                                        
                    :rules="requiredRule"
                    :disabled="linhaDigitavel.length !== 47"
                    label="Data Vencimento"
                    v-model="dataVencimento"
                  ></custom-date-picker>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                  <currency-field 
                    label="Valor (R$)" 
                    :disabled="linhaDigitavel.length !== 47"
                    v-model="valorBoleto">
                  </currency-field>
                </v-col>
                <v-col
                  style="margin-top: -20px"
                  cols="12"
                  sm="12"
                  class="text-center"
                >
                  <v-btn @click="submit()" color="success">
                    <v-icon left>mdi-content-save</v-icon>Cadastrar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-data-table
            :fixed-header="true"
            fix-header
            :headers="headers"
            :items="cliente.boletos"
            :single-select="false"
            :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
            :items-per-page="10"
            class="elevation-1 mt-3"
          >
            <template v-slot:item.linhaDigitavel="{ item }">{{
              item.linhaDigitavel
            }}</template>
            <template v-slot:item.dataVencimento="{ item }">{{
              item.dataVencimento | date
            }}</template>
            <template v-slot:item.valor="{ item }">{{
              item.valor | currency(true)
            }}</template>
            <template v-slot:item.visualizouEm="{ item }">{{
              item.visualizouEm | date
            }}</template>
            <template v-slot:item.acao="{ item }">
              <v-menu bottom left v-if="$vuetify.breakpoint.sm">
                <template v-slot:activator="{ on }">
                  <v-btn dark icon v-on="on" color="accent">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="deleteBoleto(item)">
                    <v-list-item-title>Excluir</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-tooltip v-if="!$vuetify.breakpoint.sm" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="deleteBoleto(item)"
                    >mdi-trash-can-outline</v-icon
                  >
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import rules from "@/utils/rules";
import * as moment from "moment";
import CustomInputMask from "@/components/shared/CustomInputMask";
import CustomDatePicker from "@/components/shared/CustomDatePicker";
import CurrencyField from "@/components/shared/CurrencyField";

export default {
  mixins: [rules],
  components: {
    CustomInputMask,
    CustomDatePicker,
    CurrencyField
  },
  data() {
    return {
      cpf: "",
      linhaDigitavel: "",
      dataVencimento: null,
      valorBoleto: null,
      cliente: {
        boletos: [],
      },
    };
  },
  mounted() {
    if (this.$route.params.cpf) {
      this.cpf = this.$route.params.cpf;
      this.buscarCpf();
    }
  },
  methods: {
    ...mapActions("boleto", ["salvar", "atualizar", "remover", "obterPorCpf"]),
    limpar() {
      this.cliente = { boletos: [] };
      this.$refs.form.reset();
    },
    ctrlV() {
      if (this.linhaDigitavel) {
        const splitted = this.linhaDigitavel.split(" ");
        this.linhaDigitavel = splitted.join("").replace(/\D/g, "");
        this.valorBoleto = this.calcularValorBoleto();
        this.dataVencimento = this.calcularDataVencimento();
      }
    },
    calcularDataVencimento() {
      if (this.linhaDigitavel && this.linhaDigitavel.length === 47) {
        var vencimento = parseInt(this.linhaDigitavel.slice(33, 37));
        var dataInicialFebraban = new Date(1997, 10 - 1, 7);

        Date.prototype.adicionarDias = function (dias) {
          var data = new Date(this.valueOf());
          data.setDate(data.getDate() + dias);
          return data;
        };

        var dataVenc = dataInicialFebraban.adicionarDias(vencimento);
        return dataVenc;
      }

      return null;
    },
    calcularValorBoleto() {
      if (this.linhaDigitavel && this.linhaDigitavel.length === 47) {
        const valorStr = this.linhaDigitavel.slice(37, 45);
        const decimalStr = this.linhaDigitavel.slice(45, 47);
        const valor = parseFloat(parseInt(valorStr) + "." + decimalStr);
        return valor;
      }

      return null;
    },
    onChangeLinhaDigitavel() {
      this.valorBoleto = this.calcularValorBoleto();
      this.dataVencimento = this.calcularDataVencimento();
    },
    deleteBoleto(item) {
      this.openConfirmDialog({
        message: `Confirma a exclusão do boleto com Data de Vencimento ${this.formatDate(
          item.dataVencimento
        )}?`,
        yes: () => {
          this.remover(item.id).then(() => {
            this.cliente.boletos = this.cliente.boletos.filter(
              (x) => x.id !== item.id
            );
            this.openAlertSuccess("Boleto excluído com sucesso!");
            this.setFocusLinhaDigital();
          });
        },
      });
    },
    enviarDados() {
      const jsonData = {
        linhaDigitavel: this.linhaDigitavel,
        dataVencimento: this.dataVencimento,
        valor: this.valorBoleto,
        idUsuario: this.cliente.id,
      };

      this.salvar(jsonData).then((data) => {
        this.cliente.boletos.push(data);
        this.openAlertSuccess("Boleto inserido com sucesso!");
        this.linhaDigitavel = "";
        this.setFocusLinhaDigital();
      });
    },
    submit() {
      if (this.$refs.formBoleto.validate()) {
        if (this.dataVencimento !== null && this.valorBoleto !== null) {
          if (moment(this.dataVencimento).isBefore(moment())) {
            this.openDialog({
              messages: "Data de Vencimento é inferior a Data de Hoje",
              alert: null,
              callback: () => {
                this.setFocusLinhaDigital();
              },
            });            
          } else {
            this.enviarDados();
          }
        } else {
          this.openDialog({
            messages: "Linha Digitável está inválida",
            alert: null,
            callback: () => {
              this.setFocusLinhaDigital();
            },
          });
        }
      }
    },
    setFocusLinhaDigital() {
      setTimeout(() => {
        this.$refs.txtLinhaDigitavel.focus();
      }, 100);
    },
    buscar() {
      if (this.$refs.form.validate()) {
        this.buscarCpf();
      }
    },
    buscarCpf() {
      this.obterPorCpf(this.cpf)
        .then((data) => {
          this.cliente = data;
          this.setFocusLinhaDigital();
        })
        .catch(() => {
          this.limpar();
        });
    },
  },
  computed: {    
    headers() {
      let headersArray = [];
      headersArray.push({
        text: "Linha Digitável",
        align: "left",
        sortable: false,
        value: "linhaDigitavel",
        class: "disabled",
      });

      headersArray.push({
        text: "Data Vencimento",
        align: "center",
        sortable: false,
        value: "dataVencimento",
        class: "disabled",
      });

      headersArray.push({
        text: "Valor",
        align: "right",
        sortable: false,
        value: "valor",
        class: "disabled",
      });

      headersArray.push({
        text: "Vizualizou Em:",
        align: "center",
        sortable: false,
        value: "visualizouEm",
        class: "disabled",
      });

      headersArray.push({
        text: "Ação",
        value: "acao",
        sortable: false,
        align: "center",
      });

      return headersArray;
    },
  },
};
</script>